var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0082 12.0464L16.0404 11.8719C16.6476 8.58642 16.9512 6.94368 16.0516 5.86259C15.152 4.78149 13.4815 4.78149 10.1403 4.78149L7.21041 4.78149C3.86929 4.78149 2.19874 4.78149 1.29913 5.86259C0.399528 6.94368 0.703125 8.58642 1.31032 11.8719L1.34258 12.0464C1.77647 14.3942 1.99342 15.5681 2.82739 16.2621C3.66136 16.956 4.85513 16.956 7.24267 16.956L10.1081 16.956C12.4956 16.956 13.6894 16.956 14.5234 16.2621C15.3573 15.5681 15.5743 14.3942 16.0082 12.0464Z",
    fill: "#0E204D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8V8C13 10.2091 11.2091 12 9 12V12C6.79086 12 5 10.2091 5 8V8",
    stroke: "white",
    strokeWidth: 1.125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5V5C4 2.79086 5.79086 1 8 1L9 1C11.2091 1 13 2.79086 13 5V5",
    stroke: "#0E204D",
    strokeWidth: 1.125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shoppingBag.4410a232ab0ca242f6287868c1cfe4cd.svg";
export { ForwardRef as ReactComponent };